import { render, staticRenderFns } from "./PbLink.vue?vue&type=template&id=6631af78&"
import script from "./PbLink.vue?vue&type=script&lang=js&"
export * from "./PbLink.vue?vue&type=script&lang=js&"
import style0 from "./PbLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports